import React, { useState } from "react";
import "../../styles/aboutPagesCards.css";
import teste1 from "../../img/teste1.jpg";
import teste2 from "../../img/teste2.jpg";
import teste3 from "../../img/teste3.jpg";
import teste4 from "../../img/teste4.jpg";
import teste5 from "../../img/teste5.jpg";

const AboutPsicoTcc: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState<string>("");
    const [currentIndex, setCurrentIndex] = useState<number>(0);

    const images = [teste1, teste2, teste3, teste4, teste5];

    const openLightbox = (imageUrl: string, index: number) => {
        setCurrentImage(imageUrl);
        setCurrentIndex(index);
        setIsOpen(true);
    };

    const closeLightbox = () => {
        setIsOpen(false);
    };

    const nextImage = () => {
        if (currentIndex < images.length - 1) {
            setCurrentIndex(currentIndex + 1);
            setCurrentImage(images[currentIndex + 1]);
        }
    };

    const prevImage = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1);
            setCurrentImage(images[currentIndex - 1]);
        }
    };
    return (
        <div className="about_pages_intro_cards">
            <div className="teste_zoom_two">
            <p className="about_pages_intro_cards_text">
                <h2 className='sub_title'><b>Transformando pensamentos, emoções e comportamentos com a TCC</b></h2>
                <br />
                <p>A Psicologia com foco na Terapia Cognitivo-Comportamental (TCC) oferece uma abordagem estruturada, prática e baseada em evidências científicas para o tratamento de questões emocionais e comportamentais. Voltada para o presente e com metas claras, a TCC auxilia o paciente na identificação e reestruturação de pensamentos disfuncionais que afetam o bem-estar e a qualidade de vida.</p>
                <br />
                <p>Por meio de técnicas validadas, a TCC promove o desenvolvimento de habilidades de enfrentamento, autoconhecimento, regulação emocional e mudança de hábitos, sempre com foco na autonomia do paciente e na promoção de saúde mental duradoura.</p>
                <br />
                <p><b>Quando procurar um psicólogo com abordagem TCC?</b></p>
                <br />

                    <li>Quadros de ansiedade generalizada, fobias, crises de pânico ou transtorno obsessivo-compulsivo (TOC);</li>
                    <li>Sintomas de depressão, desmotivação ou sensação de vazio;</li>
                    <li>Estresse crônico, irritabilidade e dificuldade para lidar com pressões diárias;</li>
                    <li>Problemas de autoestima, insegurança e autocrítica excessiva;</li>
                    <li>Dificuldades nos relacionamentos interpessoais, familiares ou afetivos;</li>
                    <li>Transtornos alimentares, compulsões ou comportamentos autodestrutivos;</li>
                    <li>Busca por crescimento pessoal, equilíbrio emocional e desempenho profissional.</li>
                <br />
                <p><b>Benefícios da Terapia Cognitivo-Comportamental</b></p>
                <br />
                    <li>Resultados objetivos e mensuráveis com foco em metas terapêuticas;</li>
                    <li>Maior consciência sobre os padrões de pensamento e comportamento;</li>
                    <li>Desenvolvimento de estratégias práticas para lidar com situações desafiadoras;</li>
                    <li>Redução significativa dos sintomas de ansiedade e depressão;</li>
                    <li>Melhora da autoestima, das habilidades sociais e da qualidade de vida como um todo.</li>
                
                <br />  
                <p><b>TCC: clareza, foco e transformação emocional</b></p>
                <br />  
                <p>A Terapia Cognitivo-Comportamental é indicada para adolescentes, adultos e idosos que buscam compreender seus processos mentais e construir mudanças reais e sustentáveis. Com um olhar atento ao presente, a TCC promove a reconstrução de narrativas internas, auxiliando o indivíduo a alcançar equilíbrio emocional, relacionamentos mais saudáveis e uma vida mais plena e consciente.</p>
                <br />
            </p>
            {/* Galeria de Fotos */}
            {/*<div className="gallery-container">
                <div className="gallery">
                    <div className="gallery-item" onClick={() => openLightbox(teste1, 0)}>
                        <img src={teste1} alt="Imagem 1" />
                    </div>
                    <div className="gallery-item" onClick={() => openLightbox(teste2, 1)}>
                        <img src={teste2} alt="Imagem 2" />
                    </div>
                    <div className="gallery-item" onClick={() => openLightbox(teste3, 2)}>
                        <img src={teste3} alt="Imagem 3" />
                    </div>
                    <div className="gallery-item" onClick={() => openLightbox(teste4, 3)}>
                        <img src={teste4} alt="Imagem 4" />
                    </div>
                </div>
            </div>

            {/* Modal para imagem ampliada *
            {isOpen && (
                <div className="fancybox-container" onClick={closeLightbox}>
                    <div className="fancybox-inner">
                        <div className="fancybox-content">
                            <img className="fancybox-image" src={currentImage} alt="Imagem Ampliada" />
                        </div>

                        <div className="fancybox-toolbar">
                            <button className="fancybox-button prev" onClick={prevImage}>&lt;</button>
                            <button className="fancybox-button close" onClick={closeLightbox}>X</button>
                            <button className="fancybox-button next" onClick={nextImage}>&gt;</button>
                        </div>

                        <div className="fancybox-infobar">
                            <span>{currentIndex + 1} / {images.length}</span>
                        </div>
                    </div>
                </div> 
            )}*/}
            </div>
        </div>
    );
};

export default AboutPsicoTcc;